// src/components/mobile-app-download-button/mobile-app-download-button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SecondaryButtonFragment on UISecondaryButton {\n    __typename\n    primary\n    icon {\n      id\n      description\n    }\n    action {\n      ... on UILinkAction {\n        resource {\n          value\n        }\n        target\n      }\n    }\n    analytics {\n      linkName\n      referrerId\n      eventType\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  query MobileAppDownloadButtonQuery($context: ContextInput!, $optionalPageId: String, $referrer: String) {\n    notification(context: $context) {\n      mobileAppDownloadButton(optionalPageId: $optionalPageId, referrer: $referrer) {\n        button {\n          ...SecondaryButtonFragment\n        }\n        revealAction {\n          event\n          referrerId\n          linkName\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React2 from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/mobile-app-download-button-secondary-button/mobile-app-download-button-secondary-button.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize, UitkSecondaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var MobileAppDownloadButtonSecondaryButton = function(param) {
    var isSmall = param.isSmall, data = param.data;
    var action = data.action, analytics = data.analytics, icon = data.icon, primary = data.primary;
    var analyticsTracker = useClickTracker();
    if (!action || action.__typename !== "UILinkAction" || !icon || !analytics) {
        return null;
    }
    var onClickButton = function() {
        analyticsTracker(analytics.referrerId, analytics.linkName, void 0, []);
    };
    return /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkSecondaryButton, {
        size: UitkButtonSize.SMALL,
        tag: "a",
        href: "".concat(action.resource.value),
        target: action.target,
        onClick: onClickButton
    }, /* @__PURE__ */ React.createElement(UitkIcon, {
        name: icon.id
    }), !isSmall && primary && /* @__PURE__ */ React.createElement(UitkText, {
        whiteSpace: "nowrap"
    }, primary)));
};
MobileAppDownloadButtonSecondaryButton.fragment = fragment;
MobileAppDownloadButtonSecondaryButton.displayName = "MobileAppDownloadButtonSecondaryButton";
// src/components/mobile-app-download-button/query/mobile-app-download-button-query.tsx
import { gql as gql2 } from "@apollo/client";
var MobileAppDownloadButtonRequestQuery = gql2(_templateObject1(), MobileAppDownloadButtonSecondaryButton.fragment);
// src/components/mobile-app-download-button/mobile-app-download-button.tsx
var __GetMobileAppDownloadButton = MobileAppDownloadButtonRequestQuery;
var MobileAppDownloadButton = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var location = useLocation();
    var referrer = "".concat(location === null || location === void 0 ? void 0 : location.pathname).concat(location === null || location === void 0 ? void 0 : location.search);
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context,
        referrer: referrer
    });
    var _useQuery = useQuery(__GetMobileAppDownloadButton, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var _data_notification = data.notification, _data_notification_mobileAppDownloadButton = _data_notification.mobileAppDownloadButton, button = _data_notification_mobileAppDownloadButton.button, revealAction = _data_notification_mobileAppDownloadButton.revealAction;
    if (!button || !button.action || !button.icon || !button.analytics || !revealAction || !revealAction.linkName) {
        return null;
    }
    return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: revealAction.referrerId,
        linkName: revealAction.linkName,
        trackOnce: true
    }, /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewLarge, null, /* @__PURE__ */ React2.createElement(MobileAppDownloadButtonSecondaryButton, {
        data: button
    })), /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(MobileAppDownloadButtonSecondaryButton, {
        data: button,
        isSmall: true
    }))));
};
MobileAppDownloadButton.displayName = "MobileAppDownloadButton";
export { MobileAppDownloadButton };
//# sourceMappingURL=index.js.map